import api from './api';

export const getAllBadges = async () => {
  const response = await api.get('/badges/');
  return response.data;
};

export const getUserBadges = async (userId) => {
  const response = await api.get(`/badges/user/${userId}`);
  return response.data;
};

export const getMyBadges = async () => {
  const response = await api.get('/badges/my-badges');
  return response.data;
};

export const getBadgeLeaderboard = async () => {
  const response = await api.get('/badges/leaderboard');
  return response.data;
};
